module.exports = __webpack_public_path__ + "img/switch_ico.670703ff.png";